<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import LaisModal from 'dashboard/components-next/LaisModal.vue';
import PostSaleStatusDetailFields from './PostSaleStatusDetailFields.vue';

const props = defineProps({
  event: { type: Object, default: null },
  show: { type: Boolean, default: false },
});

const emit = defineEmits(['close']);
const { t } = useI18n();

const label = computed(
  () =>
    props.event?.to_status_label ||
    props.event?.status_label ||
    t('POST_SALE.STATUS.SELECT')
);
const formatDate = value => {
  if (!value) return t('POST_SALE.COMMON.NO_DATE');
  return new Intl.DateTimeFormat('pt-BR', { dateStyle: 'medium' }).format(
    new Date(value)
  );
};
const showsDueDate = computed(
  () =>
    ['certidoes', 'taxas'].includes(props.event?.to_status) &&
    props.event?.status_due_at
);
const observation = computed(() => {
  const message = props.event?.reason || props.event?.payload?.mensagem;
  return message ? `${formatDate(props.event?.occurred_at)} - ${message}` : '';
});
</script>

<template>
  <LaisModal
    :show="show"
    :title="label"
    max-width-class="max-w-[760px]"
    @close="emit('close')"
  >
    <template #header>
      <div class="min-w-0">
        <h2
          class="break-words text-xl font-semibold text-lais-text font-redHatDisplay"
        >
          {{ label }}
        </h2>
        <p class="mt-1 text-xs text-lais-text-muted">
          {{
            t('POST_SALE.STATUS_DETAILS.START_VALUE', {
              date: formatDate(event?.occurred_at),
            })
          }}
        </p>
      </div>
    </template>
    <div v-if="event" class="grid gap-4">
      <section
        v-if="showsDueDate"
        data-testid="post-sale-status-due"
        class="rounded-lais-sm border border-lais-border-soft bg-lais-bg-soft p-4"
      >
        <p class="text-sm font-semibold text-lais-text">
          {{ t('POST_SALE.STATUS_DETAILS.DUE') }}
        </p>
        <p class="mt-1 text-sm text-lais-text-body">
          {{ formatDate(event.status_due_at) }}
        </p>
      </section>

      <PostSaleStatusDetailFields :event="event" />

      <section
        data-testid="post-sale-status-observation"
        class="rounded-lais-sm border border-lais-border-soft bg-white p-4"
      >
        <p
          class="text-xs font-bold uppercase tracking-wide text-lais-text-muted"
        >
          {{ t('POST_SALE.STATUS_DETAILS.LAST_OBSERVATION') }}
        </p>
        <p class="mt-2 whitespace-pre-wrap text-sm text-lais-text-body">
          {{ observation || t('POST_SALE.COMMON.EMPTY_VALUE') }}
        </p>
      </section>
    </div>
  </LaisModal>
</template>
